import React from 'react';
import { PRIORITY_COLOR, SOURCE_COLOR, STAGE_COLOR, DEAL_TYPE_COLOR } from '@/lib/constants';

export function PriorityBadge({ value }) {
    if (!value) return null;
    const c = PRIORITY_COLOR[value] || '#6B7280';
    return (
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold" style={{ color: c }}>
            <span className="h-2 w-2 rounded-full" style={{ background: c }} /> {value}
        </span>
    );
}

export function SourceBadge({ value, detail }) {
    if (!value) return null;
    const c = SOURCE_COLOR[value] || '#6B7280';
    const label = value === 'Other' && detail ? `Other - ${detail}` : value;
    return (
        <span className="inline-flex items-center text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded" style={{ color: c, background: `${c}14`, border: `1px solid ${c}33` }}>
            {label}
        </span>
    );
}

export function DealTypeBadge({ value }) {
    if (!value) return null;
    const c = DEAL_TYPE_COLOR[value] || '#6B7280';
    return (
        <span className="inline-flex items-center text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded" style={{ color: c, background: `${c}14`, border: `1px solid ${c}33` }}>
            {value}
        </span>
    );
}

export function StageBadge({ value }) {
    if (!value) return null;
    const c = STAGE_COLOR[value] || '#6B7280';
    return (
        <span className="inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-full" style={{ color: c, background: `${c}14`, border: `1px solid ${c}33` }}>
            {value}
        </span>
    );
}
